import commonUtil from '../../../utils/commonUtil';

export const CSC_ADMIN_USER_ACTIVE_SESSION = 'CSC_ADMIN_USER_ACTIVE_SESSION';
export const CSC_ADMIN_USER_ACTIVE_SESSION_SUCCESS =
  'CSC_ADMIN_USER_ACTIVE_SESSION_SUCCESS';
export const CSC_ADMIN_USER_ACTIVE_SESSION_FAIL =
  'CSC_ADMIN_USER_ACTIVE_SESSION_FAIL';

export function getCSCAdminProfile() {
  const userData = {};
  userData.brand = commonUtil.getBrand();
  userData.channel = commonUtil.getChannel();
  return {
    types: [
      CSC_ADMIN_USER_ACTIVE_SESSION,
      CSC_ADMIN_USER_ACTIVE_SESSION_SUCCESS,
      CSC_ADMIN_USER_ACTIVE_SESSION_FAIL,
    ],
    promise: (client) =>
      client.post('/api/profile/csc-me', {
        data: userData,
      }),
  };
}
